import { configureStore } from '@reduxjs/toolkit';
import portfolioReducer from './features/portfolio/portfolioSlice';
import companyReducer from './features/company/companySlice';
import editCompanyReducer from './features/editCompany/editCompanySlice';

export const store = configureStore({
    reducer: {
        portfolio: portfolioReducer,
        company: companyReducer,
        editCompany: editCompanyReducer
    },
});
